export default __webpack_public_path__ + "static/media/329.aeb3c13b.png";